import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { STATUSES } from '__constants__'
import { Text } from '@qonsoll/react-design'
import { useSubfilterActions } from 'hooks'
import { useTranslations } from 'contexts/Translation'

const NewsTipStatusFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslations()

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'status',
    operand: '==',
    type: 'newsTipStatus'
  })

  const newsTipStatuses = Object.values(STATUSES.NEWS_TIP_STATUSES)?.map(
    (value) => ({ value, name: value })
  )

  return (
    <details
      open={
        localStorage.getItem(`newsTipStatus-details-visibility`) === 'opened'
      }>
      <summary onClick={onToggleDetails}>{t('News tip status')}</summary>
      {newsTipStatuses?.map((newsTipStatus, index) => (
        <Checkbox
          key={`status-${index}`}
          checked={checkIsEnabled(newsTipStatus)}
          onChange={() => onChange(newsTipStatus)}>
          <Text wordBreak="break-all">
            {newsTipStatus?.name || t('Unnamed filter')}
          </Text>
        </Checkbox>
      ))}
    </details>
  )
}

NewsTipStatusFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default NewsTipStatusFilter
